import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SystemAdmin from '../components/common/SystemAdmin';
import { useAuth } from '../contexts/AuthContext';
import { getMVPDefaultRole } from '../config/mvpConfig';
import { useCurrentUser as usePermissionCurrentUser } from '../services/queries/permissionQueries';

const AdminPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, hasRole } = useAuth();
  const { data: permissionUser } = usePermissionCurrentUser();
  const [userRole, setUserRole] = useState<string>('');

  const getUserRole = (): string => {
    if (permissionUser?.roles?.some((role) => role.isSystem || role.name === 'System Administrator')) {
      return 'system_admin';
    }
    if (user) {
      if (hasRole('system_admin')) return 'system_admin';
      if (hasRole('cs_supervisor')) return 'cs_supervisor';
      if (hasRole('cs_team')) return 'cs_team';
      if (hasRole('cb_supervisor')) return 'cb_supervisor';
      if (hasRole('cb_team')) return 'cb_team';
      if (hasRole('cm_supervisor')) return 'cm_supervisor';
      if (hasRole('cm_team')) return 'cm_team';
    }
    return getMVPDefaultRole();
  };

  useEffect(() => {
    setUserRole(getUserRole());
  }, [user, hasRole, permissionUser]);

  const handleNavigation = (view: string) => {
    const mainAppViews = ['home', 'profile', 'settings', 'support-tickets'];
    if (mainAppViews.includes(view)) {
      navigate(view === 'home' ? '/' : `/${view}`);
    }
  };

  return (
    <SystemAdmin
      userRole={userRole}
      onNavigate={handleNavigation}
      onRoleChange={setUserRole}
    />
  );
};

export default AdminPage;
